export const SQLDecodeRecursive = (inObject) => {
    let outObject, value, key

    if (typeof inObject !== 'object' || inObject === null) {
        return inObject // Return the value if inObject is not an object
    }

    // Create an array or object to hold the values
    outObject = Array.isArray(inObject) ? [] : {}

    for (key in inObject) {
        value = inObject[key]

        // Recursively (deep) copy for nested objects, including arrays
        if (typeof value === 'object' && value !== null) {
            outObject[key] = SQLDecodeRecursive(value)
        } else {
            if (typeof value === 'string' && value !== null) {
                outObject[key] = SQLDecode(value)
            } else {
                outObject[key] = value
            }
        }
    }

    return outObject
}

export const SQLEncodeRecursive = (inObject) => {
  let outObject, value, key

  if (typeof inObject !== 'object' || inObject === null) {
      return inObject // Return the value if inObject is not an object
  }

  // Create an array or object to hold the values
  outObject = Array.isArray(inObject) ? [] : {}

  for (key in inObject) {
      value = inObject[key]

      // Recursively (deep) copy for nested objects, including arrays
      if (typeof value === 'object' && value !== null) {
          outObject[key] = SQLEncodeRecursive(value)
      } else {
          if (typeof value === 'string' && value !== null) {
              outObject[key] = SQLEncode(value)
          } else {
              outObject[key] = value
          }
      }
  }

  return outObject
}

export function SQLEncode(str) {
    if (str != undefined && typeof str == 'string') {
        return str
            .replace(/;/g, '&semi;')
            .replace(/'/g, '&apos;')
            .replace(/"/g, '&quot;')
            .replace(/\n/g, '&NewLine;')
    } else {
        return str
    }
}

export function SQLDecode(str) {
    if (str != undefined && typeof str == 'string') {
        return str
            .replace(/&apos;/g, "'")
            .replace(/&quot;/g, '"')
            .replace(/&NewLine;/g, '\n')
            .replace(/&semi;/g, ';')
    } else {
        return str
    }
}

export const uuid = () =>
    ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    )
